import { createApp } from "vue/dist/vue.esm-bundler"
import { registerLayoutComponents } from "@/components/layout/global"
import Index from "@/components/bill_pay/public_form/Index.vue"
import Workbench from '@lib/workbench'

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp(Index)
  app.provide('workbench', new Workbench())
  registerLayoutComponents(app)

  app.mount("#bill-pay")
})
